import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';
import { ActionRef } from '@/App/types/actionRef';
import { ScreenRef } from '@/App/types/screenRef';
import { selectDeleteProfile } from '@/features/user/deleteProfile/selectDeleteProfile';

const DeleteAccountPage = lazy(() =>
  import('@/components/pages/DeleteAccount/DeleteAccountPage').then(({ DeleteAccountPage }) => ({
    default: DeleteAccountPage,
  })),
);

export const DeleteAccountRoute: AppRouteConfig = {
  key: 'delete-account-page',
  path: '/delete_account/:token/:locale?',
  component: DeleteAccountPage,
  screenRef: ScreenRef.DELETE_PROFILE,
  actionRef: ActionRef.DELETE,
  selector: selectDeleteProfile,
};
